import React, { useEffect, useState } from 'react'
import AdminHeader from '../AdminHeader'
import './AdminMasters.css'
import { Button, Col, Container, Form,  Modal, Row, Spinner,  Table } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import { ProductAdd, ProductDelete, ProductFindAll, ProductUpdate } from '../../API/Api'
import AdminNav from '../../../AdminNav'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import { Switch as AntSwitch } from 'antd';
import Typography from '@mui/material/Typography';


const ProductMaster = () => {

  const [status, setStatus] = useState(true);// State to track the switch status
  const [show, setShow] = useState(false);
  const [productName, setProductName] = useState();
  const [data, setData] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [productId, setProductId] = useState();
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  

//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setProductId('');
    setProductName('');
    setStatus(false); 
  };

  const handleEditShow = (item) => {
    setProductId(item.product_id);
    setProductName(item.product_name);
    setStatus(item.status === 1 ? true : false);
    setShowEdit(true);
  };


 // Function to fetch data from the backend
const fetchData = () => {
  axios
    .get(`${ProductFindAll}/${branchId}`)
    .then((res) => {
      console.log("Data fetched successfully:", res.data);
      setData(res.data);
    })
    .catch((err) => {
      console.error("Failed to fetch data:", err);
      toast.error("Failed to fetch data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};

// Function to save data
const saveData = (e) => {
  e.preventDefault();
  setLoading(true);

  // Send the status to the backend (1 for ON, 2 for OFF)
  const backendValue = status ? 1 : 2;
  // Add your logic to send the value to the backend
  console.log('Sending value to backend:', backendValue);
  handleClose(); // Close the modal after submitting

  if (!productName) {
    alert("Product Name is required");
    return;
  }

  const formData = {
    product_name: productName,
    status: backendValue,
    branch_id: branchId
  };

  console.log("FormData:", formData);

  axios
    .post(ProductAdd, formData)
    .then((res) => {
      console.log("res...",res);
      if (res.data.message === "SAVED") {
        console.log("Data saved successfully:", res.data);
        toast.success("Data Saved Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setProductName('');
        setStatus('');
        fetchData(); // Refresh data after saving
        setLoading(false);
      }
    })
    .catch((err) => {
      console.error("Failed to save data:", err);
      toast.error("Failed to save data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};


// Function to update data
const updateProduct = () => {
  if (!productName) {
    alert("Product Name is required");
    return;
  }

  const formData = {
    product_name: productName,
    status: status,
  };

  console.log("FormData:", formData);

  axios
    .put(`${ProductUpdate}${productId}`, formData)
    .then((res) => {
      if (res.data === "UPDATE") {
        console.log("Data updated successfully:", res.data);
        toast.success("Data Updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        fetchData(); // Refresh data after updating
        handleEditClose();
      }
    })
    .catch((err) => {
      console.error("Failed to update data:", err);
      toast.error("Failed to update data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};

useEffect(() => {
  fetchData(); // Fetch initial data on component mount
}, []);

    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios  
        .delete(`${ProductDelete}${item.product_id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          fetchData();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };

  const handleSwitchChange = () => {
    setStatus(!status); // Toggle the switch status
  };

       //HEADING FONT ===================

       const headingStyle = {
        fontSize: '27px',
        fontWeight: 'bold',
        textAlign: 'center',
      };
    
      const subheadingStyle = {
        color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
        fontWeight: 300, // Assuming this is the font weight for "font-[300]"
        textShadow:"3px 1px 5px rgb(180, 180, 180)",
      };


  return (
    <Container fluid>

  
        <Row className='m-0'> <AdminHeader /> </Row>

   <Row className='BgImg px-md-5 ' style={{backgroundColor:"rgb(214, 234, 248)"}}>

   {/* ====================== table =============== */}
   <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{display:"flex"}}>
   <Row className='pt-3'>
    {/* <Col style={{color:"darkorange",display:"flex",justifyContent:"center",textShadow:"3px 1px 5px rgb(180, 180, 180)",fontFamily:"monospace"}}>
    <h4>Product Master</h4>
    </Col> */}
    <div className="heading text-black pt-3 pt-2 pt-md-3 mt-2 mt-md-1 mb-2" style={headingStyle}>
           <span style={subheadingStyle}>Product</span> Master
           </div>
   </Row>
   <div  style={{display:"flex"}}>
    <button className='p-1 px-2' onClick={handleShow}  style={{backgroundColor:"papayawhip",border:"2px solid darkslategray",borderTopRightRadius:"15px"}}><b >ADD</b></button>
   </div>

   

   <div style={{ overflowY: 'auto'}}>
  <div style={{ overflowX: 'auto' }}>
     <Table striped bordered hover size="sm" className='shadow mb-5 mt-2' style={{textAlign:"center"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product Name</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product Status</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' style={{fontSize:"14px"}}>
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.product_name}</td>
                 <td style={{ textAlign:"center"}}>
                 {item.status === 1 ? "Active" : "InActive"}
                 </td>
                 <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"rgb(255, 93, 0)",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => handleEditShow(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td>
                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
   </Row>


   {/* ========================== Modal ============= */}
   {show && !showEdit && ( // Check if 'show' is true and 'showEdit' is false
        <Modal className='shadow rounded' show={show} onHide={handleClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor: "rgb(214, 234, 248)", color: "black" }}>
            <Modal.Title >
              <p style={{ fontSize: "18px" }} className='text-center mt-2'><b>Product Master</b></p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className='m-0'>
              <Row className='mt-3' style={{ display: "flex" }}>
                <Col sm={4} md={4}>
                  <Form.Label><h6 >Product Name :</h6></Form.Label>
                </Col>
                <Col sm={8} md={8}>
                  <Form.Control
                    aria-label="Default select example"
                    onChange={(e) => setProductName(e.target.value)}
                    value={productName}
                    maxLength={40}
                    required
                  >
                  </Form.Control>
                </Col>
              </Row>

              <Row sm={12} md={12} className='mt-3' style={{ display: "flex" }}>
                <Col sm={4} md={4}>
                  <Form.Label><h6>Status :</h6></Form.Label>
                </Col>
                <Col sm={8} md={8}>
                  <FormGroup>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>Off</Typography>
                      <AntSwitch
                        checked={status}
                        onChange={handleSwitchChange}
                        inputProps={{ 'aria-label': 'ant design' }}
                      />
                      <Typography>On</Typography>
                    </Stack>
                  </FormGroup>
                </Col>
              </Row>
            </Row>
            <Form
            //  onSubmit={savedata}
              encType="multipart/form-data">


            </Form>
          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor: "rgb(214, 234, 248)" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleClose}>
              Cancel
            </Button>

            {
              isEditing === false ?
                <Button style={{ border: "1px solid darkslategray", backgroundColor: "darkslategray", borderRadius: "15px" }} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={saveData} disabled={loading}>
                  {loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>&nbsp;Save</div>}
                </Button>
                :
                <Button style={{ border: "1px solid darkslategray", backgroundColor: "darkslategray", borderRadius: "15px" }} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={handleClose}>
                  Update
                </Button>
            }
          </Modal.Footer>
        </Modal>
      )}

      {showEdit && !show && ( // Check if 'showEdit' is true and 'show' is false
        <Modal show={showEdit} onHide={handleEditClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor: "rgb(214, 234, 248)", color: "black" }}>
            <Modal.Title >
              <p style={{ fontSize: "18px" }} className='text-center mt-2'><b>Product Master</b></p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className='m-0'>
              <Row className='mt-3' style={{ display: "flex" }}>
                <Col sm={4} md={4}>
                  <Form.Label><h6 >Product Name :</h6></Form.Label>
                </Col>
                <Col sm={8} md={8}>
                  <Form.Control
                    aria-label="Default select example"
                    onChange={(e) => setProductName(e.target.value)}
                    value={productName}
                    required
                    maxLength={40}
                  >
                  </Form.Control>
                </Col>
              </Row>

              <Row sm={12} md={12} className='mt-3' style={{ display: "flex" }}>
  <Col sm={4} md={4}>
    <Form.Label><h6>Status :</h6></Form.Label>
  </Col>
  <Col sm={8} md={8}>
  <FormGroup>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>Off</Typography>
        <AntSwitch
          checked={status}
          onChange={handleSwitchChange}
          inputProps={{ 'aria-label': 'ant design' }}
        />
        <Typography>On</Typography>
      </Stack>
    </FormGroup>
  </Col>
</Row>

            </Row>
            <Form
            //  onSubmit={savedata}
              encType="multipart/form-data">


            </Form>
          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor: "rgb(214, 234, 248)" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleEditClose}>
              Cancel
            </Button>

            <Button style={{ border: "1px solid darkslategray", backgroundColor: "darkslategray", borderRadius: "15px" }} className='py-2 px-3 mx-2  shadow text-light' onClick={() => updateProduct(productId, productName, status)}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      )}
            {/* ============= Delete Modal ========= */}

            <Modal show={show1} onHide={handleClose1}>
        <Modal.Header style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
          <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>  Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to delete this item?</Modal.Body>
          <p className='text-end'>
          <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
            Cancel
          </Button>
          <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
            Delete
          </Button></p>
      </Modal>
</Row>

    </Container>
  )
}

export default ProductMaster